export default {
  noDataText: 'Leider wurde hier nichts geladen',
  inputRequired: 'Feld wird benötigt',
  dataIterator: {
    prevPage: 'Vorige Seite',
    nextPage: 'Nächste Seite',
    rowsPerPageAll: 'Alle',
    rowsPerPageText: 'Einträge pro Seite:',
    pageText: '{0}-{1} von {2}',
    noResultsText: 'Keine passenden Einträge gefunden'
  },
  dataTable: {
    rowsPerPageText: 'pro Seite'
  },
  roles: {
    noRoles: 'Keine Rolle zugewiesen',
    student: 'Nutzer',
    class_guest: 'Gast',
    school_guest: 'Gast der Organisation',
    moderator: 'Moderator',
    principal: 'Leitung',
    school_admin: 'Admin',
    admin: 'Aula-Admin'
  },
  rolesCompound: {
    null: 'Keine Rolle zugewiesen',
    noRoles: 'Keine Rolle zugewiesen',
    school_student: 'Nutzer',
    student: 'Nutzer in {0}',
    class_guest: 'Gast in {0}',
    school_guest: 'Gast der Organisation',
    moderator: 'Moderator in {0}',
    principal: 'Leitung',
    school_admin: 'Admin',
    admin: 'Aula-Admin'
  },
  rolesCompoundWithoutRoom: {
    school_student: 'Nutzer',
    student: 'Nutzer',
    class_guest: 'Gast',
    school_guest: 'Gast der Organisation',
    moderator: 'Moderator',
    principal: 'Leitung',
    school_admin: 'Admin',
    admin: 'Aula-Admin'
  },
  Login: {
    'button': 'Login',
    'welcome': 'Willkommen bei aula',
    'school': 'Organisation',
    'login': 'Nutzername',
    'password': 'Passwort',
    'server': 'Nutzerdefinierter Server',
    'currentServer': 'Server',
    'update': 'Aktualisierung',
    'updateServer': 'Geben Sie die URL eines benutzerdefinierten Servers mit http oder https Protokollen ein',
    'updateAlert': 'Bitte bestätigen Sie Ihren benutzerdefinierten Server, bevor Sie fortfahren',
    'serverAlert': 'Server konnte nicht erreicht werden',
    'password.reminder': 'Wenn Du eine email-Adresse eingegeben hast, kannst du dein Passwort hier neu setzen.',
    'password.reminder.noemail': 'Solltest du dein Passwort nicht mehr kennen und keine email-Adresse haben, melde dich bitte bei den Admins der Organisation.',
    'passwordError': 'Leider stimmt entweder Nutzername oder Passwort nicht.',
    'showPassword': 'Passwort anzeigen'
  },
  Footer: {
    'userTerms': 'Nutzungsbedingungen',
    'impressum': 'Impressum'
  },
  Menu: {
    'profileView': 'Profil anzeigen',
    'settings': 'Einstellungen',
    'administration': 'Administration',
    'logout': 'Logout'
  },
  Header: {
    'start': 'Start',
    'delegation': 'Beauftragungen'
  },
  Delegation: {
    'delegation.network': 'Beauftragungsnetzwerk',
    'selected': 'Ausgewählt',
    'all.delegation': 'Beauftragung für alle Themen',
    'minimum.delegation.number': 'Untergrenze Anzahl Beauftragungen',
    'user.search': 'Nutzer suchen',
    'noDelegation': 'Keine Beauftragungen in diesem Geltungsbereich.',
    'delegateYourVote': 'Beauftrage deine Stimme!'
  },
  Space: {
    'wildIdeas': 'Wilde Ideen',
    'ideaTopics': 'Themenraum',
    'subtitle': 'Was soll sich verändern?',
    'description': 'Du kannst hier jede lose Idee, die du im Kopf hast, einwerfen und kannst für die Idee abstimmen und diese somit "auf den Tisch bringen".',
    'newIdea': 'Neue Idee',
    'ask.on.no.ideas.search.results': 'Erstelle Deine eigene Idee!',
    'info': 'Schau dir die Ideen an, die andere haben. Welche davon würdest du unterstützen? Hast du eine eigene Idee, die nicht dabei ist? Dann stell sie hier ein!'
  },
  IdeaListing: {
    'sortByAge': 'Datum',
    'sortBySupporters': 'Unterstützung',
    'sortByName': 'Alphabetisch',
    'sortByRandom': 'Zufällig',
    'sortByRecentComments': 'Zuletzt kommentiert',
    'sortByFeasibility': 'Machbarkeit',
    'sortByResult': 'Ergebnis',
    'search': 'Suche',
    'noIdeas': 'Hier wurden noch keine Ideen aufgeschrieben.',
    'ideaSubtitle': 'Von {0} am {1}',
    'noComments': 'Keine Verbesserungsvorschläge',
    'numComments': '{0} Verbesserungsvorschläge',
    'noSupporters': 'Keine Unterstützer',
    'numSupporters': '{0} Unterstützer',
    'isFeasible': 'Umsetzbar',
    'isNotFeasible': 'Nicht umsetzbar',
    'waitingForFeasibility': 'Idee wird geprüft',
    'resultsPhase': 'Ergebnis',
    'votesFor': '{0} dafür',
    'votesAgainst': '{0} dagegen'
  },
  Topic: {
    'topic': 'Thema',
    'goBack': 'Zurück',
    'info': 'In diesen Themen befinden sich Ideen. Über die Themen in der Ausarbeitungsphase kannst du diskutieren, eigene Ideen hinzufügen und Verbesserungsvorschläge machen. Wenn das Thema in der Abstimmungsphase ist, kannst du über Ideen darin abstimmen.',
    'introTitle': 'Diese Themen sind in der Diskussion',
    'introDescription': 'Hinter jedem Thema können mehrere passende Ideen stehen, die hier vor der Abstimmung diskutiert werden',
    'newTopic': 'Neues Thema',
    'view.theme': 'Thema anzeigen',
    'topic.options': 'Optionen',
    'edit.topic': 'Thema bearbeiten',
    'delete': 'Thema Löschen',
    'advance.topic.phase': 'Nächste Phase',
    'back.topic.phase': 'Vorherige Phase',
    'to.topic.list': 'Zu Allen Themen',
    'allIdeas': 'Alle Ideen',
    'tab.approved.ideas': 'Angenommene Ideen',
    'winnerIdeas': 'Angenommen',
    'winnerIdea': 'Angenommen',
    'delegates': 'Beauftrage Stimmen',
    'changeDelegate': 'Beauftragung ändern',
    'changeDelegateUnassigned': 'Nicht Zugewiesen',
    'back.phase.limit': "Thema {0} konnte nicht zurückgesetzt werden: steht schon auf 'Ausarbeitung'",
    'phase.change': 'Thema {0} wurde von {1} nach {2} verschoben.',
    'phaseTimeLeft': 'Endet {0}',
    'phaseComplete': 'Zeit abgelaufen. Nächste Phase kann von einem Moderator eingeleitet werden.',
    'your.delegate': 'Derzeit stimmt für dich ab: {0}',
    'cantCreateIdea': 'Diesem Thema können keine Ideen hinzugefügt werden.',
    'notFound': 'Dieses Thema wurde leider nicht gefunden.',
    'edit': 'Thema bearbeiten'
  },
  TopicPhase: {
    'wildIdeas': 'Wilde-Ideen-Phase',
    'edit_topics': 'Ausarbeitungphase',
    'feasibility': 'Prüfungsphase',
    'vote': 'Abstimmungsphase',
    'finished': 'Ergebnisphase',
    'confirmDialogMessage': 'Sie verändern den Ablauf des gesamten Prozesses für alle Benutzer für diese Idee. Eventuell gehen dabei Informationen verloren. Wollen Sie das wirklich?'
  },
  TopicCreation: {
    'pageTitleCreating': 'Thema erstellen',
    'pageTitleEditing': 'Thema bearbeiten',
    'title': 'Wie soll der Titel des Themas lauten?',
    'titleHint': 'z.B. Computerraum',
    'description': 'Beschreibung des Themas',
    'descriptionHint': 'Was haben die Ideen dieses Themas gemeinsam?',
    'selectIdeas': 'Wähle wilde Ideen für dieses Thema',
    'publish': 'Veröffentlichen',
    'cancel': 'Abbrechen',
    'topic.name.empty': 'Title des Themas: ungültige Eingabe: zu wenig Input (erwartet: nicht leer)',
    'topic.description.empty': 'Thema: darf nicht leer sein',
    'topicNotFound': 'Das zu bearbeitende Thema wurde nicht gefunden',
    'currentIdeas': 'Ideen in diesem Thema'
  },
  IdeaCreation: {
    'title': 'Deine Idee',
    'titleWithTopic': 'Deine Idee für das Thema "{0}"',
    'name': 'Wie soll deine Idee heißen?',
    'nameExample': 'z.B. bessere Ausstatung im Computerraum',
    'suggestion': 'Was möchtest du vorschlagen?',
    'suggestionDescription': 'Hier kannst du deine Idee so ausführlich wie möglich beschreiben',
    'previewShow': 'Vorschau einblenden',
    'selectCategory': 'Kann deine Idee einer der folgenden Kategorieren zugeordnet werden?',
    'publish': 'Idee veröffentlichen',
    'backToTopic': 'Zurück zum Thema',
    'yourDelegates': 'Derzeit Stimmt für dich ab:'
  },
  UserProfile: {
    'unknown': 'Unbekannt',
    'delegate.your.vote': 'Für {0} Organisation beauftragen',
    'delegates': 'Deine Beauftragung für die Organisation',
    'remove.delegation': 'Beauftragung für {0} entziehen',
    'report': 'Melden',
    'profile': 'Profil',
    'edit': 'Profil bearbeiten',
    'tab.supported.ideas': 'Erstellte Ideen',
    'tab.delegate.for': 'Für wen stimme ich ab?',
    'tab.my.delegate': 'Wer stimmt für mich ab?',
    'report.descripton': 'Hier kannst du ein Nutzerprofil wegen eines verletzenden oder anstößigen Inhalts beim Moderationsteam melden. Das Team erhält eine Benachrichtigung und wird die Idee schnellstmöglich überprüfen. Bitte gib unten einen Grund an, warum du den Inhalt für anstößig oder verletzend hältst.',
    'report.title': 'Report',
    'report.question': 'Warum möchtest du das Nutzerprofil melden?',
    'report.send': 'Abschicken',
    'delegate.idea': 'Geltungsbereich:',
    'delegates.singular': '{0} Stimme von {1}',
    'delegates.plural': '{0} Stimmen von {1}'
  },
  SettingsMenu: {
    'personal': 'Persönlich',
    'password': 'Passwort',
    'translation': 'Übersetzung',
    'notifications': 'Benachrichtigungen'
  },
  UserSettings: {
    'email': 'E-mailadresse (optional)',
    'change.password': 'Passwort ändern',
    'currentPassword': 'aktuelles Passwort',
    'newPassword': 'neues Passwort',
    'newPasswordConfirm': 'neues Passwort bestätigen',
    'newPasswordConfirmError': 'Die Passwörter stimmen nicht überein',
    'oldPasswordRequired': 'Passwort-Felder sind nur teilweise ausgefüllt.',
    'PasswordRequired': 'Bitte füllen Sie das Passwortfeld aus.',
    'save': 'Änderungen speichern'
  },
  NotificationSettings: {
    'allow': 'Benachrichtige mich...',
    'newSchoolIdea': '...wenn in der Schule eine neue wilde Idee gepostet wurde',
    'newClassIdea': '...wenn in meiner Klasse eine neue wilde Idee gepostet wurde',
    'newSugestionYourIdea': '...wenn jemand einen Verbesserungsvorschlag zu deiner Idee hat',
    'ideaPhaseChange': '...wenn deine Idee in einer neuen Phase ist',
    'schoolTopicPhaseChange': '...wenn ein schulweites Thema in eine neue Phase kommt',
    'classTopicPhaseChange': '...wenn ein Thema in deiner Klasse in eine neue Phase kommt',
    'receiveDelegatedVote': '...wenn jemand dir seine Stimme überträgt',
    'ideaQuorumPassed': '...wenn deine wilde Idee das Quorum passiert',
    'votedForYou': '...wenn jemand mit deiner Stimme abgestimmt hat',
    'votingExpiring': '...wenn eine Abstimmung bald endet.',
    'subjectReport': '...wenn ein Inhalt gemeldet wird',
    'voteReceived': '...wenn deine Idee eine Abstimmung gewonnen hat'
  },
  Form: {
    'save': 'Änderungen speichern',
    'delete': 'Löschen',
    'cancel': 'Abbrechen',
    'close': 'Schließen',
    'edit': 'Bearbeiten',
    'picture': 'Bild auswählen',
    'ok': 'OK',
    'fileSizeExceeded': 'Das Bild ist mit {1} MB zu groß, die maximale Dateigröße beträgt {0} MB. Bitte verkleinere die Dateigröße und versuche es dann erneut.'
  },
  IdeaCategories: {
    'Regeln': 'Regeln',
    'Ausstattung': 'Ausstattung',
    'Aktivatäten': 'Aktivitäten',
    'Unterricht': 'Unterricht',
    'Meetings': 'Treffen',
    'Zeit': 'Zeit',
    'Umgebung': 'Umgebung',
    'Sonstiges': 'Sonstiges'
  },
  Comment: {
    'title': '{0} Verbesserungsvorschläge, sortiert nach',
    'authorCreated': 'von <b>{0}</b> am {1}',
    'tally': '{0} Stimmen',
    'isDeleted': '[ Kommentar gelöscht ]',
    'editedBy': 'bearbeitet von {0}',
    'sortByNew': 'Neu',
    'sortByVotes': 'Stimmen',
    'formTitleEdit': 'Verbesserungsvorschlag bearbeiten',
    'formTitleCreate': 'Neuer Verbesserungsvorschlag',
    'formReplyTo': 'Antwort auf {0}',
    'formLabelTitle': 'Dein Verbesserungsvorschlag',
    'reply': 'Antworten',
    'submit': 'Veröffentlichen',
    'edit': 'Bearbeiten',
    'reset': 'Zurücksetzen',
    'delete': 'Löschen',
    'cancel': 'Abbrechen',
    'snackbarCreated': 'Verbesserungsvorschlag veröffentlicht',
    'disabled': 'In dieser Phase können keine Verbesserungsvorschläge mehr eingereicht werden.',
    'add': 'Vorschlag hinzufügen'
  },
  Idea: {
    'idea': 'Idee',
    'wildIdeas': 'Wilde Ideen',
    'authorCreated': 'von <b>{0}</b>',
    'votes.pro': '{0} Quorum-Stimmen',
    'suggestion': 'Verbesserungsvorschlag',
    'supporterCount': '<span class="supportNum">{0}</span> von <span class="neededNum">{1}</span>',
    'votesCount': '<span class="supportNum">{0} dafür</span>, <span class="againstNum">{1} dagegen</span>',
    'create.topic': 'Thema anlegen',
    'isPossible': 'Durchführbar',
    'notPossible': 'Nicht durchführbar',
    'feasibilityReason': 'Begründen Sie bitte hier, warum die Idee nicht durchführbar ist. Wenn sie durchführbar ist, kann hier ein Kommentar stehen oder dieses Feld kann leer bleiben.',
    'statement': 'Statement abgeben',
    'feasibleDesc': 'Was möchtest du sagen?',
    'support': 'Unterstützen',
    'noSupport': 'Nicht mehr unterstützen',
    'category': 'Diese Idee gehört zur Kategorie {0}',
    'noCategory': 'Diese Idee gehört zu keiner Kategorie',
    'topicDescription': 'In {0} für Thema',
    'new.suggestion': 'Neuer Verbesserungsvorschlag',
    'suggestion.author': '{0} am {1}',
    'suggestion.answer': 'Antworten',
    'suggestion.report': 'Melden',
    'suggestion.edit': 'Bearbeiten',
    'suggestion.delete': 'Löschen',
    'move': 'Idee verschieben',
    'back.to.topic': 'Zum Ideenraum',
    'ask.first.suggestion': 'Gib den ersten Verbesserungsvorschlag ab!',
    'markWinner': 'Als "gewonnen" markieren',
    'unmarkWinner': '"gewonnen" zurücknehmen',
    'notWinner': 'nicht gewonnen',
    'proVotes': 'Dafür',
    'voteInFavor': 'Dafür',
    'voteAgainst': 'Dagegen',
    'againstVotes': 'Dagegen',
    'quorum': 'Quorum',
    'delete': 'Idee Löschen',
    'feasibilityLabel': 'Durchführbarkeits Begründung'
  },
  IdeaMove: {
    'move.idea.title': 'Idee verschieben',
    'move.question': "Soll die Idee '{0}' aus '{1}' verschoben werden?",
    'move.to.wild.ideas': "Nach 'wilde Ideen'",
    'move.confirm': 'Verschieben'
  },
  AdminMenu: {
    'title': 'Administration',
    'ideaSpace': 'Räume',
    'pages': 'Seiten',
    'phaseDuration': 'Dauer der Phasen',
    'categories': 'Kategorien',
    'quorum': 'Quorum',
    'holidays': 'Urlaubsmodus',
    'users': 'Gruppen & Nutzer',
    'protocol': 'Protokolle',
    'changePhase': 'Phasen verschieben',
    'termsOfUse': 'Nutzungsbedingungen ändern',
    'links': 'Links',
    'roleEdit': 'Benutzerrollen'
  },
  AdminLinks: {
    'linkName': 'Name',
    'links': 'Links',
    'linkPosition': 'Ort',
    'addLink': 'Link hinzufügen',
    'linkUrl': 'URL'
  },
  AdminPhaseTime: {
    'phaseWorking': 'Wie viele Tage soll die Ausarbeitungphase dauern?',
    'phaseVoting': 'Wie viele Tage soll die Abstimmungphase dauern?',
    'isNotInteger': 'Nur ganzzahlige Werte erlaubt',
    'days': 'Tage'
  },
  Category: {
    'category': 'Kategorie',
    'resetFilter': 'Zurücksetzen'
  },
  AdminCategories: {
    'usageNote': 'Klicke auf bestehende Kategorien, um deren Namen und Beschreibung zu ändern.',
    'deleteHeader': 'Kategorie Löschen',
    'deleteText': 'Kategorie "{0}" wirklich löschen? Alle darin enthaltenen Ideen haben dann keine Kategorie mehr.',
    'deleteConfirm': 'Unwiderrufbar löschen',
    'deleteCancel': 'Zurück',
    'snackbarDeleted': 'Die Kategorie wurde gelöscht',
    'snackbarDeleteFailed': 'Die Kategorie konnte nicht gelöscht werden',
    'titleAdd': 'Kategorie hinzufügen',
    'titleEdit': 'Kategorie "{0}" bearbeiten',
    'formName': 'Name',
    'position': 'Stelle',
    'formDescription': 'Beschreibung',
    'formPickIcon': 'Kategorie-Bild auswählen',
    'formCreate': 'Erstellen',
    'formSave': 'Sichern',
    'formReset': 'Zurücksetzen',
    'formCancel': 'Abbrechen',
    'snackbarCreated': 'Erstellt',
    'snackbarSaved': 'Gesichert',
    'isDefault': 'Default',
    'positionIsNotNumeric': 'Die Stelle muss eine Zahl sein'
  },
  AdminQuorum: {
    'school': 'Wie hoch soll das Quorum organisationsweit sein?',
    'class': 'Wie hoch soll das Quorum raumnweit sein?',
    'schoolPercent': '% aller Nutzer der Organisation',
    'classPercent': '% aller Nutzer des Raums'
  },
  AdminHolidays: {
    'description': 'Im Urlaubsbetrieb sind die folgenden Änderungen zu beachten:',
    'description.1': 'Die Zeit bis zum Ablauf von Ausarbeitungsphase und Abstimmungsphase wird angehalten.',
    'description.2': 'In der wilde-Ideen-Phase kann nicht mehr gewählt werden.',
    'description.3': 'In der Abstimmugnsphase kann nicht mehr gewählt werden.',
    'description.4': 'Es kann nicht mehr auf Kommentare abgestimmt werden.',
    'current.status': 'Aktueller Status',
    'normal.status': 'Normalbetrieb (aufgetaut)',
    'holiday.status': 'Urlaubsbetrieb (eingefroren)',
    'change.status': 'Status setzen!'
  },
  AdminIdeaSpace: {
    'formIdeaSpace': 'Raum',
    'delete': 'Raum Löschen',
    'deleteAlert': 'Achtung! Möchtest du diese Raum wirklich löschen? Das löscht alle damit verbundenen Nutzerrollen, die Ideen darin, die Kommentare, Themen, Abstimmungen und Delegationen. Diese Aktion kann nicht mehr rückgängig gemacht werden!',
    'formIdeaSpaceName': 'Raum Name',
    'formIdeaSpaceDescription': 'Beschreibung',
    'formIdeaSpaceUrlName': 'Raum Url Name',
    'add': 'Raum hinzufügen'
  },
  AdminCommunity: {
    'add': 'Organisation hinzufügen',
    'save': 'Organisation speichern',
    'newCommunityName': 'Neue Gemenschaft Name',
    'community': 'Organisation',
    'tableHeaderName': 'Name',
    'mainSpaceName': 'Hauptideenraum Name',
    'impressumEdit': 'Impressum bearbeiten',
    'disableDelegation': 'Beauftragungen deaktivieren?',
    'termsEdit': 'Nutzungsbedingungen bearbeiten'
  },
  AdminUsers: {
    'bulkAddUserRole': 'Rolle zuweisen',
    'bulkRemoveUserRole': 'Rolle entfernen',
    'bulkRemoveUserRoleNoUsers': 'Die ausgewählte Rolle ist keinem Nutzer zugewiesen.',
    'bulkRemoveUserRoleCount': 'Von {0} Nutzer(n) wird die Rolle entfernt.',
    'titleAdd': 'Neue Nutzer hinzufügen',
    'titleEdit': 'Nutzer "{0}" ändern',
    'columnHasSetPassword': 'Passwort zurückgesetzt',
    'columnHasSetPassword-true': 'Ja',
    'columnHasSetPassword-false': 'Nein',
    'columnActions': '',
    'columnUserRole': 'Benutzerrolle',
    'searchLabel': 'Suche',
    'searchNoResults': 'Für deine Suche nach {0} wurden leider keine Nutzer gefunden',
    'formFirstName': 'Vorname',
    'formLastName': 'Nachname',
    'formLogin': 'Nutzername',
    'formLoginSuggestion': 'Nutzername: {0}',
    'formLoginUniqueError': 'Es gibt schon einen Nutzer \'{0}\' in dieser Organisation. Bitte gib einen anderen Namen ein.',
    'formEmail': 'Email (optional)',
    'formGroup': 'Rolle',
    'formIdeaSpace': 'Raum',
    'formAddRole': 'Rolle hinzufügen',
    'formNoSpaceSelected': 'Nicht zugewiesen',
    'formRoleRequiresSpace': 'Bitte wähle für diese Rolle eine dazugehörige Raum',
    'formCreate': 'Erstellen',
    'formSave': 'Sichern',
    'formReset': 'Zurücksetzen',
    'formCancel': 'Abbrechen',
    'formClose': 'Schließen',
    'deleteBulkUsersQuestion': 'Möchten Sie die ausgewählten Nutzer wirklich unwiederruflich löschen?',
    'deleteHeader': 'Nutzer Löschen',
    'deleteText': 'Nutzer "{0}" wirklich löschen?',
    'deleteConfirm': 'Unwiderrufbar löschen',
    'deleteCancel': 'Zurück',
    'snackbarCreated': '{0} Nutzer erstellt',
    'snackbarSaved': 'Nutzerdaten gesichert',
    'snackbarDeleted': 'Nutzer wurde(n) gelöscht',
    'snackbarRoleAdded': 'Rolle wurde hinzugefügt',
    'snackbarRoleDeleted': 'Rolle wurde entfernt',
    'snackbarDeleteFailed': 'Nutzer konnte nicht gelöscht werden',
    'snackbarDuplicateGroup': 'Der Nutzer hat diese Rolle bereits',
    'csvDialog': 'Aus CSV-Datei',
    'csvFilePicker': 'Datei auswählen',
    'csvFormatError': 'Bitte sicherstellen, dass alle benötigten Spalten vorhanden sind.',
    'csvMissingCellsError': 'Einträge konnten nicht geladen werden, da Vor- oder Nachname fehlen',
    'csvEncodingError': 'Bitte sicherstellen, dass die CSV-Datei als "CSV UTF8"-Datei gespeichert wurde.',
    'csvGenericError': 'Es gab einen Fehler beim Laden der CSV-Datei:',
    'loadingStudentsError': 'Bitte lade erst eine Tabelle mit Nutzern',
    'csvTitle': 'Aus CSV laden',
    'csvInstructions': 'Hier können neue Nutzer aus einer Tabellen-Datei erstellt werden. Die Tabelle sollte im Format CSV (mit Kopfzeile) gespeichert werden und die Spalten "Vorname" und "Nachname" enthalten. Optional kann eine Spalte "Email" angegeben werden.',
    'csvReset': 'Zurücksetzen',
    'csvTableHeader': 'Vorschau der {0} Nutzer',
    'csvSave': 'Alle sichern',
    'csvClose': 'Schließen',
    'resetPassword': 'Passwort zurücksetzen',
    'confirmResetPassword': 'Passwort zurücksetzen für Nutzer "{0}"?',
    'newPassword': 'Neues Passwort',
    'usernameExists': 'Nutzername existiert bereits',
    'selectAll': 'Alle auswählen',
    'unselectAll': 'Auswahl löschen',
    'selected': 'ausgewählte(n)',
    'selectedUsers': 'Ausgewählte Nutzer',
    'selectUserRole': 'Auswahl der Benutzerrolle',
    'delete': 'löschen',
    'addRole': 'Rolle hinzufügen',
    'removeRole': 'Rolle entfernen',
    'users': 'Nutzer',
    'passwordlist': 'Passwortliste',
    'snackbarAddRole': 'Rolle wurde hinzugefügt',
    'snackbarAddRoleFailed': 'Rolle konnte nicht hinzugefügt werden',
    'snackbarRemoveRole': 'Rolle wurde entfernt',
    'snackbarRemoveRoleFailed': 'Rolle konnte nicht entfernt werden',
    'downloadSampleCSV': 'Beispiel Datei herunterladen'
  },
  AdminPages: {
    pageName: 'Seitenname',
    confirmDelete: '"{0}" wirklich löschen?',
    add: 'Seite hinzufügen'
  },
  AdminPassList: {
    title: 'Passwortliste',
    selectSpaceLabel: 'Raum wählen',
    selectRoleLabel: 'Rolle wählen',
    selectRolePlaceholder: 'Alle Rollen',
    buttonPrint: 'Drucken',
    buttonBack: 'Zurück',
    labelUsername: 'Nutzername',
    labelPassword: 'Passwort',
    labelNoPassword: 'Passwort zurückgesetzt'
  },
  AdminChangePhase: {
    'title': 'Phasen verschieben',
    'description.1': 'ACHTUNG! GEFAHR!',
    'description.2': 'Diese Seite erlaubt es, Themen in beide Richtungen (Zukunft und Vergangenheit) zu verschieben.',
    'description.3': 'Dies ist ein experimentelles Feature, und kann zu unerwartetem Verhalten führen. Bitte nur mit',
    'description.4': 'gutem Grund und nur nach Rücksprache mit den zuständigen Moderatoren durchführen!'
  },
  AdminTermsOfUse: {
    'description': 'Bitte passen Sie hier die Nutzungsbedingungen an'
  },
  Snackbar: {
    'close': 'Schließen',
    'networkError': 'Keine Verbindung zum Aula-Server',
    'serverError': 'Das hat leider nicht geklappt',
    'clientError': 'Das hat leider nicht geklappt',
    'rightsError': 'Das ist leider nicht erlaubt',
    'formError': 'Bitte überprüfe deine Eingaben noch einmal',
    'missingImage': 'Bitte fügen sie ein Bild zum Thema hinzu'
  },
  GroupsUsers: {
    'add': 'Benutzer hinzufügen'
  },
  Permissions: {
    'noPermission': 'Keine Berechtigung für diese Aktion',
    'idea': {
      'title': 'Idee',
      'create_idea': {
        'title': 'Idee erstellen',
        'description': 'Erlaubt die Erstellung von Ideen'
      },
      'delete_idea': {
        'title': 'Idee löschen',
        'description': 'Erlaubt das Löschen von Ideen'
      },
      'support_idea': {
        'title': 'Idee unterstützen',
        'description': 'Erlaubt die Unterstützung von Ideen'
      },
      'edit_idea': {
        'title': 'Idee bearbeiten',
        'description': 'Erlaubt die Bearbeitung fremder Ideen'
      },
      'approve_idea': {
        'title': 'Idee zulassen',
        'description': 'Erlaubt die Zulassung von Ideen für die folgende Abstimmung'
      },
      'vote_idea': {
        'title': 'Idee abstimmen',
        'description': 'Erlaubt es, über Ideen abzustimmen (Wahlrecht)'
      },
      'mark_idea_winner': {
        'title': 'Idee als Gewinner markieren',
        'description': 'Erlaubt die Markierung einer Idee als Gewinner'
      }
    },
    'comment': {
      'title': 'Verbesserungsvorschlag',
      'create_comment': {
        'title': 'Verbesserungsvorschlag erstellen',
        'description': 'Erlaubt die Erstellung von Verbesserungsvorschlägen'
      },
      'delete_comment': {
        'title': 'Verbesserungsvorschlag löschen',
        'description': 'Erlaubt das Löschen von Verbesserungsvorschlägen'
      },
      'support_comment': {
        'title': 'Verbesserungsvorschlag unterstützen',
        'description': 'Erlaubt die Unterstützung von Verbesserungsvorschlägen'
      },
      'edit_comment': {
        'title': 'Verbesserungsvorschlag bearbeiten',
        'description': 'Erlaubt die Bearbeitung fremder Verbesserungsvorschläge'
      }
    },
    'topic': {
      'title': 'Thema',
      'create_topic': {
        'title': 'Thema erstellen',
        'description': 'Erlaubt die Erstellung von Themen'
      },
      'edit_topic': {
        'title': 'Thema bearbeiten',
        'description': 'Erlaubt die Bearbeitung von Themen'
      },
      'delete_topic': {
        'title': 'Thema löschen',
        'description': 'Erlaubt das Löschen von Themen'
      },
      'add_topic_idea': {
        'title': 'Idee in Thema erstellen',
        'description': 'Erlaubt die Erstellung von Ideen in Themen'
      },
      'change_topic_phase': {
        'title': 'Themenphase verändern',
        'description': 'Erlaubt die Veränderung der aktuellen Phase eines Themas'
      }
    },
    'user': {
      'title': 'Benutzer',
      'create_user': {
        'title': 'Nutzer erstellen',
        'description': 'Erlaubt die Erstellung von neuen Nutzern '
      },
      'delete_user': {
        'title': 'Nutzer löschen',
        'description': 'Erlaubt das Löschen von Nutzern'
      },
      'edit_user': {
        'title': 'Nutzer bearbeiten',
        'description': 'Erlaubt die Bearbeitung von Nutzern'
      }
    },
    'role': {
      'title': 'Rolle',
      'create_role': {
        'title': 'Rolle erstellen',
        'description': 'Erlaubt die Erstellung von Rollen'
      },
      'delete_role': {
        'title': 'Rolle löschen',
        'description': 'Erlaubt das Löschen von Rollen'
      },
      'edit_role': {
        'title': 'Rolle bearbeiten',
        'description': 'Erlaubt die Bearbeitung von Rollen'
      }
    },
    'idea_space': {
      'title': 'Raum',
      'create_room': {
        'title': 'Raum erstellen',
        'description': 'Erlaubt die Erstellung von Räumen'
      },
      'delete_room': {
        'title': 'Raum löschen',
        'description': 'Erlaubt das Löschen von Räumen'
      },
      'edit_room': {
        'title': 'Raum bearbeiten',
        'description': 'Erlaubt die Bearbeitung von Räumen'
      }
    },
    'category': {
      'title': 'Kategorie',
      'create_category': {
        'title': 'Kategorie erstellen',
        'description': 'Erlaubt die Erstellung von neuen Kategorien'
      },
      'delete_category': {
        'title': 'Kategorie löschen',
        'description': 'Erlaubt das Löschen von Kategorien'
      },
      'edit_category': {
        'title': 'Kategorie bearbeiten',
        'description': 'Erlaubt die Bearbeitung von Kategorien'
      }
    },
    'admin': {
      'title': 'Administration',
      'see_admin': {
        'title': 'Admin Oberfläche sehen',
        'description': 'Erlaubt Zungang zu der Admin Oberfläche'
      }
    },
    'pages': {
      'title': 'Seiten',
      'create_page': {
        'title': 'Seite erstellen',
        'description': 'Erlaubt die Erstellung von neuen Seiten'
      },
      'edit_pages': {
        'title': 'Seite bearbeiten',
        'description': 'Erlaubt die Bearbeitung von Seiten'
      },
      'delete_page': {
        'title': 'Seite löschen',
        'description': 'Erlaubt das Löschen von Seiten'
      },
      'edit_page': {
        'title': 'Seite bearbeiten',
        'description': 'Erlaubt das Bearbeiten von Seiten'
      }
    }
  },
  RoleEdit: {
    validityTypes: {
      'idea_space': '...ausgewählter Raum',
      'school_and_idea_space': '...Hauptraum und ausgewählter Raum',
      'school': '...nur im Hautpraum',
      'all': '...alle Räume'
    },
    'userRole': 'Benutzerrolle',
    'userRoleEditTile': 'Benutzerrollen von {0}',
    'userRoleAssigned': 'Zugewiesene Benutzerrollen',
    'allValidityWarning': 'Dieser Benutzer kann alle Räume sehen, da die Rolle ein enstprechendes Recht enthält.',
    'allValidityAffectedRoles': 'Betroffene Rollen: ',
    'assignRole': 'Rolle zuweisen',
    'saveSuccess': 'Änderungen erfolgreich gespeichert',
    'saveError': 'Bei dem Speichern der Änderungen ist ein Fehler aufgetreten',
    'createSuccess': 'Rolle erfolgreich erstellt',
    'createError': 'Bei dem Erstellen der Rolle ist ein Fehler aufgetreten',
    'deleteSuccess': 'Rolle erfolgreich entfernt',
    'deleteError': 'Beim dem Löschen der Rolle ist ein Fehler aufgetreten',
    'saveChanges': 'Änderungen speichern',
    'deleteRole': 'Rolle entfernen',
    'createRole': 'Rolle erstellen',
    'createRoleDialogTitle': 'Neue Benutzerrolle anlegen',
    'createRoleDialogLabel': 'Name der neuen Benutzerrolle',
    'fetchError': 'Beim Abruf der Benutzerollen ist ein Fehler aufgetreten',
    'validFor': 'Wo?'
  },
  Translation: {
    'apply': 'Sprache auswählen',
    'translationLanguage': 'Übersetzungssprache',
    'selectLanguage': 'Wählen Sie eine Übersetzungssprache',
    'Bulgarian': 'Bulgarisch',
    'Chinese': 'Chinesisch',
    'Czech': 'Tschechisch',
    'Danish': 'Dänisch',
    'Dutch': 'Niederländisch',
    'English': 'Englisch',
    'Estonian': 'Estnisch',
    'Finnish': 'Finnisch',
    'French': 'Französisch',
    'German': 'Deutsch',
    'Greek': 'Griechisch',
    'Hungarian': 'Ungarisch',
    'Italian': 'Italienisch',
    'Japanese': 'Japanisch',
    'Lithuanian': 'Litauisch',
    'Latvian': 'Lettisch',
    'Polish': 'Polnisch',
    'Portuguese': 'Portugiesisch',
    'Romanian': 'Rumänisch',
    'Russian': 'Russisch',
    'Slovak': 'Slowakisch',
    'Slovenian': 'Slowenisch',
    'Spanish': 'Spanisch',
    'Swedish': 'Schwedisch'
  }
}
